// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RxgC","option":"styles_option__2mBku","active":"styles_active__3A5cX"};